// Simple logger utility
export const logger = {
  warn: (message: string, ...args: any[]) => console.warn(message, ...args),
  error: (message: string, ...args: any[]) => console.error(message, ...args),
  info: (message: string, ...args: any[]) => console.info(message, ...args),
  debug: (message: string, ...args: any[]) => console.debug(message, ...args),
};

export const dp = (num: number, digits = 2): string => {
  const lang = 'en-GB';
  if (num == null) {
    return null;
  }
  return Intl.NumberFormat(lang, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(num);
};

export const numberFormatter = (digits = 2): ((params) => string) => {
  return (params: { value }): string => {
    if (params.value == null) {
      return '-';
    }
    return dp(params.value, digits);
  };
};
